import React from 'react';

const DisclaimerBanner = () => (
  <div className="chatbot-disclaimer" role="note" aria-live="polite">
    AI-generated responses may be inaccurate.
  </div>
);

export default DisclaimerBanner;
